import { Repository } from '@/forms/api/repository-factory';
import getParams from '@/forms/helpers/get-params';
import { SEND_FORM_DATA } from '@/forms/constants/services';

const resource = 'form';
///onboarding/application/upsert/v1.1
///onboarding/application/v2/upsert/v1.1
const submitEndpoint = '/onboarding/application/upsert/v1.1';
//const submitEndpoint = '/onboarding/application-test/upsert/v1.1';

export default {
    getFormByCif(payload) {
        return Repository.post(`${resource}/cif`, { payload }, {
            params: getParams(SEND_FORM_DATA),
        });
    },

    formSubmission(payload) {
        return Repository.put(submitEndpoint, {...payload }, {
            params: getParams(SEND_FORM_DATA),
        });
    },
};